export class FieldType {
  static TextField = 'TextField';
  static Autocomplete = 'Autocomplete';
  static NumberFieldPrecision = 'NumberFieldPrecision';
  static Select = 'Select';
  static MultiSelect = 'MultiSelect';
  static MultiSelectAndChips = 'MultiSelectAndChips';
  static Checkbox = 'Checkbox';
  static DateField = 'DateField';
  static SlideToggle = 'SlideToggle';
  static Upload = 'Upload';
  static Radio = 'Radio';
  static FormsArray = 'FormsArray';
  static Password = 'Password';
  static EditorField = 'EditorField';
  static TextArea = 'TextArea';
  static NumberStepInput = 'NumberStepInput';
  static ButtonToggle = 'ButtonToggle';
  static RadioCheckboxTile = 'RadioCheckboxTile';
}
